export default {"src":"/_next/static/media/download_icon.cfd8109c.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};